/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w2GXN278dkQ2gQTVQnPehW
// Component: Nuu-c5xv3Sku

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import PopoverFrameTitle from "../../components/sidebar/PopoverFrameTitle"; // plasmic-import: _qAXa8aqLB77/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_plasmic_kit_data_binding.module.css"; // plasmic-import: w2GXN278dkQ2gQTVQnPehW/projectcss
import sty from "./PlasmicPopoverFrame.module.css"; // plasmic-import: Nuu-c5xv3Sku/css

createPlasmicElementProxy;

export type PlasmicPopoverFrame__VariantMembers = {};
export type PlasmicPopoverFrame__VariantsArgs = {};
type VariantPropType = keyof PlasmicPopoverFrame__VariantsArgs;
export const PlasmicPopoverFrame__VariantProps = new Array<VariantPropType>();

export type PlasmicPopoverFrame__ArgsType = {
  showTitle?: boolean;
  popoverContent?: React.ReactNode;
};
type ArgPropType = keyof PlasmicPopoverFrame__ArgsType;
export const PlasmicPopoverFrame__ArgProps = new Array<ArgPropType>(
  "showTitle",
  "popoverContent"
);

export type PlasmicPopoverFrame__OverridesType = {
  popoverFrame?: Flex__<"div">;
  propTitle?: Flex__<typeof PopoverFrameTitle>;
  contentWrap?: Flex__<"div">;
};

export interface DefaultPopoverFrameProps {
  showTitle?: boolean;
  popoverContent?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicPopoverFrame__RenderFunc(props: {
  variants: PlasmicPopoverFrame__VariantsArgs;
  args: PlasmicPopoverFrame__ArgsType;
  overrides: PlasmicPopoverFrame__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {
          showTitle: true,
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"popoverFrame"}
      data-plasmic-override={overrides.popoverFrame}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.popoverFrame
      )}
    >
      <PopoverFrameTitle
        data-plasmic-name={"propTitle"}
        data-plasmic-override={overrides.propTitle}
        className={classNames("__wab_instance", sty.propTitle)}
      />

      <div
        data-plasmic-name={"contentWrap"}
        data-plasmic-override={overrides.contentWrap}
        className={classNames(projectcss.all, sty.contentWrap)}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.popoverContent,
        })}
      </div>
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  popoverFrame: ["popoverFrame", "propTitle", "contentWrap"],
  propTitle: ["propTitle"],
  contentWrap: ["contentWrap"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  popoverFrame: "div";
  propTitle: typeof PopoverFrameTitle;
  contentWrap: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPopoverFrame__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPopoverFrame__VariantsArgs;
    args?: PlasmicPopoverFrame__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicPopoverFrame__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPopoverFrame__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPopoverFrame__ArgProps,
          internalVariantPropNames: PlasmicPopoverFrame__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPopoverFrame__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "popoverFrame") {
    func.displayName = "PlasmicPopoverFrame";
  } else {
    func.displayName = `PlasmicPopoverFrame.${nodeName}`;
  }
  return func;
}

export const PlasmicPopoverFrame = Object.assign(
  // Top-level PlasmicPopoverFrame renders the root element
  makeNodeComponent("popoverFrame"),
  {
    // Helper components rendering sub-elements
    propTitle: makeNodeComponent("propTitle"),
    contentWrap: makeNodeComponent("contentWrap"),

    // Metadata about props expected for PlasmicPopoverFrame
    internalVariantProps: PlasmicPopoverFrame__VariantProps,
    internalArgProps: PlasmicPopoverFrame__ArgProps,
  }
);

export default PlasmicPopoverFrame;
/* prettier-ignore-end */
